"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateAllHashtagsAndHandles = validateAllHashtagsAndHandles;

/**
 * Validates that all given hashtags and handles are formatted correctly.
 *
 * @example
 *   validateAllHashtagsAndHandles(['#hashtag', '@handle']); // => true
 *   validateAllHashtagsAndHandles(['@#hashtag']); // => false
 */
function validateAllHashtagsAndHandles(tags) {
  var validChars = /^(#|@)\w+$/;
  return tags.every(function (tag) {
    return validChars.test(tag);
  });
}